import React, { useContext, useEffect, useState } from 'react'
import './Search.css';

const Search = ({params}) => {
    const [symbolList, setSymbolList] = useState([])

    const DEMO = true;

    const SYMBOL_LIST = [
        "AAL",
        "AAPL",
        "AAP",
        "ABBV",
        "ABC",
        "ABT",
        "ACN",
        "ADBE",
        "ADI",
        "ADM",
        "ADP",
        "ADSK",
        "ADS",
        "AEE",
        "AEP",
        "AES",
        "AET",
        "AFL",
        "AGN",
        "AIG",
        "AIV",
        "AIZ",
        "AJG",
        "AKAM",
        "ALB",
        "ALGN",
        "ALK",
        "ALLE",
        "ALL",
        "ALXN",
        "AMAT",
        "AMD",
        "AME",
        "AMGN",
        "AMG",
        "AMP",
        "AMT",
        "AMZN",
        "ANDV",
        "ANSS",
        "ANTM",
        "AON",
        "AOS",
        "APA",
        "APC",
        "APD",
        "APH",
        "APTV",
        "ARE",
        "ARNC",
        "ATVI",
        "AVB",
        "AVGO",
        "AVY",
        "AWK",
        "AXP",
        "AYI",
        "AZO",
        "A",
        "BAC",
        "BAX",
        "BA",
        "BBT",
        "BBY",
        "BDX",
        "BEN",
        "BF.B",
        "BHF",
        "BHGE",
        "BIIB",
        "BK",
        "BLK",
        "BLL",
        "BMY",
        "BRK.B",
        "BSX",
        "BWA",
        "BXP",
        "CAG",
        "CAH",
        "CAT",
        "CA",
        "CBG",
        "CBOE",
        "CBS",
        "CB",
        "CCI",
        "CCL",
        "CDNS",
        "CELG",
        "CERN",
        "CFG",
        "CF",
        "CHD",
        "CHK",
        "CHRW",
        "CHTR",
        "CINF",
        "CI",
        "CLX",
        "CL",
        "CMA",
        "CMCSA",
        "CME",
        "CMG",
        "CMI",
        "CMS",
        "CNC",
        "CNP",
        "COF",
        "COG",
        "COL",
        "COO",
        "COP",
        "COST",
        "COTY",
        "CPB",
        "CRM",
        "CSCO",
        "CSRA",
        "CSX",
        "CTAS",
        "CTL",
        "CTSH",
        "CTXS",
        "CVS",
        "CVX",
        "CXO",
        "C",
        "DAL",
        "DE",
        "DFS",
        "DGX",
        "DG",
        "DHI",
        "DHR",
        "DISCA",
        "DISCK",
        "DISH",
        "DIS",
        "DLR",
        "DLTR",
        "DOV",
        "DPS",
        "DRE",
        "DRI",
        "DTE",
        "DUK",
        "DVA",
        "DVN",
        "DWDP",
        "DXC",
        "D",
        "EA",
        "EBAY",
        "ECL",
        "ED",
        "EFX",
        "EIX",
        "EL",
        "EMN",
        "EMR",
        "EOG",
        "EQIX",
        "EQR",
        "EQT",
        "ESRX",
        "ESS",
        "ES",
        "ETFC",
        "ETN",
        "ETR",
        "EVHC",
        "EW",
        "EXC",
        "EXPD",
        "EXPE",
        "EXR",
        "FAST",
        "FBHS",
        "FB",
        "FCX",
        "FDX",
        "FE",
        "FFIV",
        "FISV",
        "FIS",
        "FITB",
        "FLIR",
        "FLR",
        "FLS",
        "FL",
        "FMC",
        "FOXA",
        "FOX",
        "FRT",
        "FTI",
        "FTV",
        "F",
        "GD",
        "GE",
        "GGP",
        "GILD",
        "GIS",
        "GLW",
        "GM",
        "GOOGL",
        "GOOG",
        "GPC",
        "GPN",
        "GPS",
        "GRMN",
        "GS",
        "GT",
        "GWW",
        "HAL",
        "HAS",
        "HBAN",
        "HBI",
        "HCA",
        "HCN",
        "HCP",
        "HD",
        "HES",
        "HIG",
        "HII",
        "HLT",
        "HOG",
        "HOLX",
        "HON",
        "HPE",
        "HPQ",
        "HP",
        "HRB",
        "HRL",
        "HRS",
        "HSIC",
        "HST",
        "HSY",
        "HUM",
        "IBM",
        "ICE",
        "IDXX",
        "IFF",
        "ILMN",
        "INCY",
        "INFO",
        "INTC",
        "INTU",
        "IPG",
        "IP",
        "IQV",
        "IRM",
        "IR",
        "ISRG",
        "ITW",
        "IT",
        "IVZ",
        "JBHT",
        "JCI",
        "JEC",
        "JNJ",
        "JNPR",
        "JPM",
        "JWN",
        "KEY",
        "KHC",
        "KIM",
        "KLAC",
        "KMB",
        "KMI",
        "KMX",
        "KORS",
        "KO",
        "KR",
        "KSS",
        "KSU",
        "K",
        "LB",
        "LEG",
        "LEN",
        "LH",
        "LKQ",
        "LLL",
        "LLY",
        "LMT",
        "LNC",
        "LNT",
        "LOW",
        "LRCX",
        "LUK",
        "LUV",
        "LYB",
        "L",
        "MAA",
        "MAC",
        "MAR",
        "MAS",
        "MAT",
        "MA",
        "MCD",
        "MCHP",
        "MCK",
        "MCO",
        "MDLZ",
        "MDT",
        "MET",
        "MGM",
        "MHK",
        "MKC",
        "MLM",
        "MMC",
        "MMM",
        "MNST",
        "MON",
        "MOS",
        "MO",
        "MPC",
        "MRK",
        "MRO",
        "MSFT",
        "MSI",
        "MS",
        "MTB",
        "MTD",
        "MU",
        "MYL",
        "M",
        "NAVI",
        "NBL",
        "NCLH",
        "NDAQ",
        "NEE",
        "NEM",
        "NFLX",
        "NFX",
        "NI",
        "NKE",
        "NLSN",
        "NOC",
        "NOV",
        "NRG",
        "NSC",
        "NTAP",
        "NTRS",
        "NUE",
        "NVDA",
        "NWL",
        "NWSA",
        "NWS",
        "OKE",
        "OMC",
        "ORCL",
        "ORLY",
        "OXY",
        "O",
        "PAYX",
        "PBCT",
        "PCAR",
        "PCG",
        "PCLN",
        "PDCO",
        "PEG",
        "PEP",
        "PFE",
        "PFG",
        "PGR",
        "PG",
        "PHM",
        "PH",
        "PKG",
        "PKI",
        "PLD",
        "PM",
        "PNC",
        "PNR",
        "PNW",
        "PPG",
        "PPL",
        "PRGO",
        "PRU",
        "PSA",
        "PSX",
        "PVH",
        "PWR",
        "PXD",
        "PX",
        "PYPL",
        "QCOM",
        "QRVO",
        "RCL",
        "REGN",
        "REG",
        "RE",
        "RF",
        "RHI",
        "RHT",
        "RJF",
        "RL",
        "RMD",
        "ROK",
        "ROP",
        "ROST",
        "RRC",
        "RSG",
        "RTN",
        "SBAC",
        "SBUX",
        "SCG",
        "SCHW",
        "SEE",
        "SHW",
        "SIG",
        "SJM",
        "SLB",
        "SLG",
        "SNA",
        "SNI",
        "SNPS",
        "SO",
        "SPGI",
        "SPG",
        "SRCL",
        "SRE",
        "STI",
        "STT",
        "STX",
        "STZ",
        "SWKS",
        "SWK",
        "SYF",
        "SYK",
        "SYMC",
        "SYY",
        "TAP",
        "TDG",
        "TEL",
        "TGT",
        "TIF",
        "TJX",
        "TMK",
        "TMO",
        "TPR",
        "TRIP",
        "TROW",
        "TRV",
        "TSCO",
        "TSN",
        "TSS",
        "TWX",
        "TXN",
        "TXT",
        "T",
        "UAA",
        "UAL",
        "UA",
        "UDR",
        "UHS",
        "ULTA",
        "UNH",
        "UNM",
        "UNP",
        "UPS",
        "URI",
        "USB",
        "UTX",
        "VAR",
        "VFC",
        "VIAB",
        "VLO",
        "VMC",
        "VNO",
        "VRSK",
        "VRSN",
        "VRTX",
        "VTR",
        "VZ",
        "V",
        "WAT",
        "WBA",
        "WDC",
        "WEC",
        "WFC",
        "WHR",
        "WLTW",
        "WMB",
        "WMT",
        "WM",
        "WRK",
        "WU",
        "WYNN",
        "WYN",
        "WY",
        "XEC",
        "XEL",
        "XLNX",
        "XL",
        "XOM",
        "XRAY",
        "XRX",
        "XYL",
        "YUM",
        "ZBH",
        "ZION",
        "ZTS"
    ]

    const RESULT_DEMO = {
        "symbol": "GOOGL",
        "data": [
            {
                "date": "2013-02-08",
                "open": "390.4551",
                "high": "393.7283",
                "low": "390.1698",
                "close": "393.0777",
                "volume": "6031199",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-11",
                "open": "389.5892",
                "high": "391.8915",
                "low": "387.2619",
                "close": "391.6012",
                "volume": "4330781",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-12",
                "open": "391.2659",
                "high": "394.344",
                "low": "390.0747",
                "close": "390.7403",
                "volume": "3714176",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-13",
                "open": "390.4551",
                "high": "393.0677",
                "low": "390.375",
                "close": "391.8214",
                "volume": "2393946",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-14",
                "open": "390.2549",
                "high": "394.7644",
                "low": "389.2739",
                "close": "394.3039",
                "volume": "3466971",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-15",
                "open": "394.0937",
                "high": "397.0266",
                "low": "393.9285",
                "close": "396.8414",
                "volume": "5453980",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-19",
                "open": "398.393",
                "high": "403.9035",
                "low": "398.0376",
                "close": "403.8284",
                "volume": "5857528",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-20",
                "open": "403.0527",
                "high": "404.8895",
                "low": "396.2929",
                "close": "396.6262",
                "volume": "5522500",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-21",
                "open": "399.399",
                "high": "403.1277",
                "low": "396.0056",
                "close": "398.1628",
                "volume": "7008464",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-22",
                "open": "400.0296",
                "high": "401.0256",
                "low": "397.2969",
                "close": "400.2549",
                "volume": "4103315",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-25",
                "open": "401.5512",
                "high": "404.6092",
                "low": "395.6402",
                "close": "395.7804",
                "volume": "4602925",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-26",
                "open": "397.8975",
                "high": "398.3729",
                "low": "392.5922",
                "close": "395.4601",
                "volume": "4399988",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-27",
                "open": "397.7974",
                "high": "402.7774",
                "low": "395.9506",
                "close": "400.2899",
                "volume": "4047784",
                "Name": "GOOGL"
            },
            {
                "date": "2013-02-28",
                "open": "400.9506",
                "high": "403.8985",
                "low": "400.9155",
                "close": "401.0006",
                "volume": "4526218",
                "Name": "GOOGL"
            },
            {
                "date": "2013-03-01",
                "open": "399.2989",
                "high": "403.9736",
                "low": "398.4731",
                "close": "403.4981",
                "volume": "4346304",
                "Name": "GOOGL"
            },
            {
                "date": "2013-03-04",
                "open": "403.0527",
                "high": "411.8314",
                "low": "402.9025",
                "close": "411.1628",
                "volume": "5545624",
                "Name": "GOOGL"
            }
        ]
    }
    useEffect(() => {
        // getList()
        params.setResults(RESULT_DEMO)
    }, [])

    function getList() {

        let url = "http://localhost:5000" + "/util/list"

        fetch(url)
        .then((response) => {
            // console.log("RESPONSE", response)
            return response.json()
        })
        .then((data) => {
            console.log("DATA", data.data)
            setSymbolList(data.data)
        })
        .catch(error => {
            setSymbolList(null)
            console.log('error', error)
        });
    }

    function search(query){

        if (query === null || query === "") return

        let symbol = query

        let url = "http://localhost:5000/" + "stock/" + query

        fetch(url)
            .then((response) => {
            // console.log("RESPONSE", response)
            return response.json()
        })
        .then((data) => {
            if (data.error) return
            console.log("DATA", data)
            params.setResults(data)
        })
        .catch(error => {
            params.setResults(null)
            params.setSearchQuery("")
            console.log('error', error)
        });
    }

    return (
        <div className='SearchContainer'>
            <div className='title'>Real data, <span className='green'>real fast.</span></div>
            <div className='subtitle'>Fast, optimized, and complete data in one search.</div>
            <div className='searchbar'>
                {!DEMO && <form onSubmit={(event) => {
                    event.preventDefault()
                    search(params.searchQuery)
                    }}>
                    {symbolList && <datalist id="symbolList">
                        {SYMBOL_LIST.map((item) => {
                        return <option key={item}>{item}</option>
                        })}
                    </datalist>}
                
                    <input
                        className='stockSearch'
                        list="symbolList"
                        name="query" 
                        value={params.searchQuery} 
                        onChange={(e) => params.setSearchQuery(e.target.value)}
                        autoComplete='off'
                    />
                    <br></br>
                    {/* <button className='customButton'>Search</button> */}
                </form>}
            </div>
        </div>
    )
}

export default Search